<template>
  <router-link :to="characterURL" class="character-card">
    <div class="character-card__image">
      <img :src="urlMobile || url" :alt="name">
    </div>
    <div class="character-card__info">
      <div><b>{{name}}</b></div>
      <div v-if="type">{{type}} character</div>
      <div>First Appearance:
        <span v-if="strip">
          <router-link :to="stripURL">
            #{{firstSeen}}
          </router-link>
        </span>
        <span v-else>
          #{{firstSeen}}
        </span>
      </div>
      <div
        class="character-card__bio"
        v-if="bio"
        v-html="bio">
      </div>
    </div>
  </router-link>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'CharacterCard',
  props: {
    id: String,
    firstSeen: Number,
    name: String,
    type: String,
    url: String,
    urlMobile: String,
    bio: String,
  },
  created() {
    const stripNumber = this.firstSeen;
    this.$store.dispatch('fetchStrip', { stripNumber });
  },
  computed: {
    ...mapGetters(['getStrip']),
    strip() {
      return null;
    },
    stripURL() {
      return {
        name: 'Comic',
        params: {
          stripNumber: this.firstSeen,
        },
      };
    },
    characterURL() {
      return {
        name: 'EditCharacter',
        params: {
          id: this.id,
        },
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.character-card {
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 0 20px;
  border-radius: var(--radius-large);
  color: var(--color-dark);
  &:hover {
    background: rgba(0,0,0,0.03);
    color: var(--color-link);
  }
  @media all and (max-width: 600px) {
    display: block;
    text-align: center;
  }
  &__image {
    margin-right: 20px;
    height: 450px;
    img {
      width: 100%;
    }
    @media all and (max-width: 600px) {
      margin: 0 auto;
      max-width: 300px;
    }
  }
  &__info {
    div {
      margin-bottom: 2px;
      font-size: var(--font-input);
      &:first-child {
        margin-bottom: 10px;
        font-size: var(--font-p);
      }
    }
  }
  &__bio {
    margin-top: 20px;
  }
  > div {
    flex: 1;
  }
}
</style>
